<template>
  <v-container>
    <date-filter
      :default-filter="'today'"
      v-model="selectedDate"
      :showTime="true"
      @onSelected="getSummary"
      :loading="loading"
    ></date-filter>

    <v-row class="mt-5">
      <v-col cols="12" sm="3">
        <v-card outlined fill-height style="height: 100%;">
          <v-card-text>
            จำนวนออเดอร์ทั้งหมด
            <div class="display-2 text-right primary--text">
              <v-progress-circular
                indeterminate
                color="primary"
                v-if="loading"
              ></v-progress-circular>
              <template v-else>{{ totalorder | numberFormat }}</template>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="9">
        <v-row>
          <v-col cols="12" sm="4">
            <v-card outlined fill-height style="height: 100%;">
              <v-card-text>
                ยอดขายทั้งหมด
                <div class="display-1 text-right primary--text">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="loading"
                  ></v-progress-circular>
                  <template v-else>{{ totalamount | decimalFormat }}</template>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined fill-height style="height: 100%;">
              <v-card-text>
                ยอดขายทั้งหมด(ไม่รวมค่าขนส่ง)
                <div class="display-1 text-right primary--text">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="loading"
                  ></v-progress-circular>
                  <template v-else>{{
                    (totalamount - totalshippingcharge) | decimalFormat
                  }}</template>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined fill-height style="height: 100%;">
              <v-card-text>
                ค่าขนส่งทั้งหมด
                <div class="display-1 text-right primary--text">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="loading"
                  ></v-progress-circular>
                  <template v-else>{{ totalshippingcharge | decimalFormat }}</template>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined fill-height style="height: 100%;">
              <v-card-text>
                ยอดขายเฉลี่ย / 1 ออเดอร์
                <div class="display-1 text-right primary--text">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="loading"
                  ></v-progress-circular>
                  <template v-else>{{
                    totalorder == 0 ? 0 : (totalamount / totalorder) | decimalFormat
                  }}</template>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined fill-height style="height: 100%;">
              <v-card-text>
                ยอดขายเฉลี่ย (ไม่รวมค่าขนส่ง) / 1 ออเดอร์

                <div class="display-1 text-right primary--text">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="loading"
                  ></v-progress-circular>
                  <template v-else>{{
                    totalorder == 0
                      ? 0
                      : ((totalamount - totalshippingcharge) / totalorder) | decimalFormat
                  }}</template>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="4">
            <v-card outlined fill-height style="height: 100%;">
              <v-card-text>
                ค่าขนส่ง / 1 ออเดอร์
                <div class="display-1 text-right primary--text">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="loading"
                  ></v-progress-circular>
                  <template v-else>{{
                    totalorder == 0 ? 0 : (totalshippingcharge / totalorder) | decimalFormat
                  }}</template>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div class="headline my-5">
      สินค้าขายดี
    </div>

    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="products"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:body="{ items, pagination }">
        <tbody>
          <tr v-for="(item, index) in items" :key="item.name">
            <td>{{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}</td>
            <td>{{ item.productname }}</td>
            <td>{{ item.totalquantity | numberFormat }}</td>
            <td>{{ item.totalamount | decimalFormat }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DateFilter from "@/components/DateFilter";
export default {
  data() {
    return {
      loading: true,
      headers: [
        {
          text: "No.",
          sortable: false,
        },
        {
          value: "name",
          text: "ชื่อสินค้า",
        },
        {
          value: "quantity",
          text: "จำนวนสินค้า",
        },
        {
          value: "sales",
          text: "ขายไป",
        },
      ],
      products: [],
      selectedDate: {
        start: moment().format("YYYY-MM-DD 00:00"),
        end: moment().format("YYYY-MM-DD 23:59"),
      },
      totalamount: 0,
      totalshippingcharge: 0,
      totalorder: 0,
    };
  },
  components: {
    DateFilter,
  },
  async mounted() {
    await this.getSummary();
  },
  methods: {
    async getSummary() {
      this.loading = true;
      try {
        var response = await axios.get(
          `${this.$store.state.serverUrl}chillpainai_salesreport`,

          {
            params: {
              pageid: this.$store.state.pageid,
              userid: this.$store.state.user.user.userid,
              datefrom: this.selectedDate.start,
              dateto: this.selectedDate.end,
            },
            headers: {
              AUTHORIZATION: "BEARER xxx xxx",
            },
          }
        );

        if (response.status == 200 && response.data.responsecode == 200 && response.data.data) {
          this.products = response.data.data2;
          this.totalamount = response.data.data.totalamount ? response.data.data.totalamount : 0;
          this.totalshippingcharge = response.data.data.totalshippingcharge
            ? response.data.data.totalshippingcharge
            : 0;
          this.totalorder = response.data.data.totalorder ? response.data.data.totalorder : 0;
        } else {
          this.products = [];
          this.totalamount = 0;
          this.totalshippingcharge = 0;
          this.totalorder = 0;
        }
      } catch (error) {
        this.products = [];
        this.totalamount = 0;
        this.totalshippingcharge = 0;
        this.totalorder = 0;
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
